/**
 * @file
 * Header sticky js.
 */

(function ($, Drupal, window, document) {
  'use strict';

  // Make header sticky sticky with scroll up.
  Drupal.behaviors.secf_header_sticky = {
    attach: function (context, settings) {

      $('.header', context).once('secf-header-sticky').each(function () {
        var header = document.querySelector('.header');
        var headroom = new Headroom(header, {
          offset: 0,
          tolerance: 0,
          onNotTop : function () {
            $('body').addClass('js-scrolled');
          },
          onTop : function () {
            $('body').removeClass('js-scrolled');
          }
        });
        headroom.init();
      });
    }
  };
})(jQuery, Drupal, window, document);
